import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../styles/layer_download.css';

const TooltipLink = ({ tooltipContent = [], wk, ly, url }) => {
  const [show, setShow] = useState(false);
  const local = tooltipContent[0]?.service === 'LOCAL';
  // Preserve the existing GeoServer style URL and coverage download URLs.
  const styleUrl = local
    ? url.replace('ows?', '') + '/rest/workspaces/' + wk + '/styles/' +
      ly.split(':')[0] + '_' + ly.split(':')[1].split('_')[0] + '.sld'
    : '';
  const downloads = tooltipContent.filter(item => item.url);

  return (
    <>
      <ListGroup.Item as="button" type="button" bsPrefix="list-group-item-item-tools"
        title="Descargar capa y estilo" aria-label={`Descargar ${ly}`}
        onClick={() => setShow(true)}>
        <FontAwesomeIcon icon={faDownload} size="sm" />
      </ListGroup.Item>
      <Modal show={show} onHide={() => setShow(false)} centered
        dialogClassName="layer-download-dialog" scrollable
        aria-labelledby={`download-title-${ly}`}>
        <Modal.Header closeButton closeLabel="Cerrar">
          <Modal.Title as="h2" id={`download-title-${ly}`}>Descargar archivos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="layer-download-name">{ly}</p>
          {local ? (
            <div className="layer-download-options">
              {downloads.map((item, index) => (
                <div className="layer-download-option" key={`${item.url}-${index}`}>
                  <Button href={item.url} variant="primary" className="layer-download-action">
                    <FontAwesomeIcon icon={faDownload} aria-hidden="true" />
                    Descargar capa · GeoTIFF{downloads.length > 1 ? ` (parte ${index + 1})` : ''}
                  </Button>
                  <p>Datos geográficos para abrir en QGIS u otro SIG.</p>
                </div>
              ))}
              <div className="layer-download-option">
                <Button href={styleUrl} variant="outline-primary" className="layer-download-action">
                  <FontAwesomeIcon icon={faDownload} aria-hidden="true" />
                  Descargar estilo · SLD
                </Button>
                <p>Colores y simbología para representar la capa.</p>
              </div>
            </div>
          ) : (
            <p className="layer-download-unavailable">La descarga de capas de servicios externos no está disponible desde este portal.</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TooltipLink;
